const mvSwiper = new Swiper('.mv-swiper', {
  loop: true,
  effect: 'slide',
  centeredSlides: true,
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 1000,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: { // スマホサイズ（0px〜750px）
      slidesPerView: 1.2, // 1枚+サイドに見切れ
      spaceBetween: 10,
    },
    751: { // PCサイズ（751px以上）
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  }
});